// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"122":"7ae11260","143":"eb11fdb7","187":"4cb83297","207":"542b4b3c","383":"559509ad","682":"599ca232","734":"341b505d","761":"4610680f","848":"1923e590","880":"c6e39b39","912":"02311d0d"}[chunkId] + ".js";
};